export default __webpack_public_path__ + "static/media/faq_icon.de66a2f3.svg";